import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type PaidDriverRecord = ResultOf<
  typeof proDriverRecordQuery
>["proDriver"];
export const proDriverRecordQuery = graphql(`
  query PaidDriverRecord($id: ID!) {
    proDriver(id: $id) {
      id
      name
      date_of_birth
      email
      phone
      basedIn {
        ...CityFields
      }
      bio
      license_type
      license_number
      license_issuer
      tax_registration
      business_registration_number
      bank_name
      bank_account_name
      bank_account_number
      bank_identifier_code
      has_tow_vehicle
      tow_vehicle_type
      tow_vehicle_year
      tow_capacity_kg
      incidentCount
      created_at
      updated_at
    }
  }
`);
